<template>
<div>
    <b-table hover ref="ShopCODCommissionTable" :items="items" :fields="fields" 
    @row-selected="$emit('onRowSelected' , $event)" :per-page="search.perPage" 
    :current-page="search.page" responsive show-empty selectable>
        <template slot="HEAD_selected">
            <b-form-checkbox v-model="checkSelect" @change="$emit('selectAllRows')"></b-form-checkbox>
        </template>
        <template slot="selected" slot-scope="{ rowSelected }">
            <template v-if="rowSelected">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" autocomplete="off" class="custom-control-input" value="true" checked>
                    <label class="custom-control-label"></label>
                </div>
            </template>
            <template v-else>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" autocomplete="off" class="custom-control-input" value="false">
                    <label class="custom-control-label"></label>
                </div>
            </template>
        </template>
        <template slot="customer_type" slot-scope="row">

            <span v-if="row.item.customer_type === 'company'">นิติบุคคล</span>
            <span v-else>บุคคลธรรมดา</span>

        </template>
        <template slot="exclude_vat" slot-scope="row">

            <span v-if="row.item.customer_type === 'company'">{{row.item.exclude_vat}}</span>
            <span v-else>-</span>

        </template>
        <template slot="withholding_tax" slot-scope="row">
            <span v-if="row.item.customer_type === 'company'">{{row.item.withholding_tax}}</span>
            <span v-else>-</span>
        </template>
        <template slot="net_commission" slot-scope="row">
            <span v-if="row.item.customer_type === 'company'">{{parseFloat(row.item.commission - row.item.withholding_tax).toFixed(2)}}</span>
            <span v-else>{{parseFloat(row.item.commission).toFixed(2)}}</span>
        </template>
        
        <!-- <template slot="manage" slot-scope="row">
                                        <button class="btn px-3 btn-sm btn-info" v-b-modal.modalEditAgent @click="setValueModalEdit( row.item)">แก้ไข</button>
                                        <button class="btn px-3 btn-sm btn-danger" @click="modalDelete( row.item.id )">ลบ</button>
                                    </template> -->
    </b-table>
    <div class="mt-3">
        <b-pagination :value="search.page" @input="changePage" :total-rows="totalItems" :current-page="search.page" :per-page="search.perPage" align="right">
        </b-pagination>
    </div>
</div>
</template>

<script>
export default {
    props: {
        items: Array,
        selected: Array,
        fields: Array,
        search: Object,
        totalItems: Number,
    },
    data() {
        return {
            userLogin: '',
            checkSelect: false
        }
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"))
    },
    methods: {
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
        },
    },
    computed: {}
}
</script>
